import React from "react";

export default function Policy() {
  return (
    <>
      <style>{`
        html, body, #root {
          height: 100%;
          margin: 0;
          background-color: black; /* พื้นหลังจอสีดำ */
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
        p {
          text-align: justify;   /* จัดข้อความเต็มบรรทัด */
          line-height: 1.6;      /* เพิ่มระยะห่างให้อ่านง่าย */
          margin-bottom: 16px;   /* เว้นบรรทัด */
        }
      `}</style>


      <div
        style={{
          backgroundColor: "white", // กระดาษสีขาว
          width: "210mm",           // ความกว้าง A4
          minHeight: "297mm",       // ความสูงขั้นต่ำ A4
          padding: "20mm",
          margin: "40px 0",
          borderRadius: "6px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.5)", // เงาให้สมจริง
        }}
      >
        <h1 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
          นโยบายความเป็นส่วนตัว (Privacy Policy)
        </h1>

        <p>
          &nbsp; &nbsp;<strong>Kasetkorn</strong> เป็นแพลตฟอร์มที่พัฒนาขึ้นโดย
          <strong> บริษัท แอโร กรุ๊ป (1992) จำกัด</strong> สำหรับการจัดการสวนทุเรียน
          และการขอมาตรฐาน GAP โดยมุ่งเน้นให้เกษตรกรสามารถบริหารจัดการสวนได้อย่างมีประสิทธิภาพ
        </p>
        <p>
          &nbsp; &nbsp; การใช้ข้อมูลที่ถูกรวบรวมผ่านการใช้บริการของเรานั้น ได้ถูกจำกัดถึงจุดประสงค์ของการจัดเตรียมบริการสำหรับผู้ใช้งาน ซึ่งคุณได้มีส่วนร่วมกับเรา  นโยบายความเป็นส่วนตัวนี้อธิบายว่าเรา มีวิธีการรวบรวม, การดำเนินการ, การใช้งาน, การเผยแพร่ และการป้องกันความปลอดภัยของข้อมูลส่วนตัวที่คุณได้ระบุมาอย่างไร สำหรับจุดประสงค์ของนโยบายความเป็นส่วนตัวนี้ ข้อมูลส่วนตัวนั้นควรหมายถึงข้อมูลต่างๆ ที่เกี่ยวกับการระบุความเป็นตัวตนหรือข้อมูลส่วนบุคคล
        </p>
        <p>
          &nbsp; &nbsp; โดยการยินยอมหรือการสร้างข้อมูลส่วนบุคคลและข้อมูลนิรนามผ่านโปรแกรมโทรศัพท์มือถือของเรานั้น คุณได้เห็นด้วยกับนโยบายความเป็นส่วนตัวนี้และคุณอนุญาตอย่างชัดเจนถึงการดำเนินการของข้อมูลส่วนบุคคลและข้อมูลนิรนามของคุณในการยอมรับร่วมกันกับนโยบายความเป็นส่วนตัวนี้
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>1. การรวบรวมข้อมูล</h2>
        <p>
          &nbsp; &nbsp; ในเวลาที่ท่านใช้งานแอปพลิเคชันของเรา เราอาจรวบรวมข้อมูลส่วนบุคคลและข้อมูลนิรนามจากท่าน ข้อมูลเหล่านี้จะถูกใช้เพื่อให้บริการแก่ท่านได้อย่างมีประสิทธิภาพและปรับปรุงประสบการณ์การใช้งาน
        </p>

        <p>
          &nbsp; &nbsp;ข้อมูลที่เรารวบรวม เรารวบรวมข้อมูลส่วนบุคคลและข้อมูลนิรนามจากคุณ เมื่อคุณใช้โปรแกรมบนโทรศัพท์มือถือของเรา และเมื่อคุณส่งข้อมูลและการส่อื่อสารถึงเรา
          "ข้อมูลส่วนบุคคล" หมายถึงข้อมูลที่อนุญาตให้ผู้อื่นสามารถระบุตัวตนหรือติดต่อคุณ ได้แก่ ชื่อของคุณ, หมายเลขโทรศัพท์, รหัสไปรษณีย์, ตำแหน่งของตามที่ และที่อยู่อีเมล
          "ข้อมูลนิรนาม" หมายถึงข้อมูลเกี่ยวกับคุณที่ไม่เกี่ยวข้องหรือไม่เชื่อมต่อกับข้อมูลส่วนบุคคล

        </p>
        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>2. การใช้ข้อมูลของเรา</h2>
        <p>
          &nbsp; &nbsp;ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับเราจะถูกนำไปใช้เพื่อวัตถุประสงค์ต่างๆ ดังนี้ สำหรับสร้างและรักษาบัญชีของท่าน, เพื่อการจัดการและให้บริการต่างๆ ของเรา, เพื่อระบุตัวตนของท่านในระบบ, เพื่อส่งอีเมลยืนยันเมื่อสร้างบัญชีใหม่, เพื่อส่งการแจ้งเตือนที่ท่านกำหนดไว้, เพื่อปรับปรุงและพัฒนาบริการของเรา และเพื่อการติดต่อสื่อสารที่เกี่ยวข้องกับการใช้บริการ
        </p>
        <p>
          &nbsp; &nbsp;2.1 ข้อมูลตำแหน่งที่ตั้ง (Location/GPS)
        </p>
        <p>
          &nbsp; &nbsp;วัตถุประสงค์ในการเก็บข้อมูล:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• แสดงตำแหน่งฟาร์มบนแผนที่เพื่อให้เกษตรกรสามารถจัดการพื้นที่ปลูกได้อย่างมีประสิทธิภาพ
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• บันทึกพิกัดที่อยู่ฟาร์มเพื่อการอ้างอิงและการวางแผนการผลิต
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ค้นหาและแนะนำพื้นที่ปลูกทุเรียนใกล้เคียง เพื่อการแลกเปลี่ยนข้อมูลระหว่างเกษตรกร
        </p>
        <p>
          &nbsp; &nbsp;หมายเหตุ: ข้อมูลตำแหน่งจะถูกใช้เฉพาะในบริบทของการจัดการฟาร์มเท่านั้น และไม่มีการติดตามตำแหน่งแบบเรียลไทม์
        </p>
        <p>
          &nbsp; &nbsp;2.2 รหัสบัตรประชาชน
        </p>
        <p>
          &nbsp; &nbsp;วัตถุประสงค์ในการเก็บข้อมูล:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ยืนยันตัวตนของเกษตรกร (Know Your Customer - KYC) เพื่อความปลอดภัยของบัญชีและป้องกันการใช้งานโดยไม่ได้รับอนุญาต
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• เชื่อมต่อฐานข้อมูลกับกรมวิชาการเกษตร เพื่อการขอรับรองมาตรฐาน GAP และโครงการสนับสนุนเกษตรกรจากภาครัฐ
        </p>
        <p>
          &nbsp; &nbsp;การคุ้มครองข้อมูล: รหัสบัตรประชาชนจะถูกเข้ารหัสและเก็บรักษาอย่างปลอดภัยตามมาตรฐาน PDPA พ.ศ. 2562 ไม่มีการเปิดเผยต่อบุคคลที่สามโดยไม่ได้รับอนุญาต
        </p>
        <p>
          &nbsp; &nbsp;2.3 Device ID และข้อมูลการใช้งาน (Analytics)
        </p>
        <p>
          &nbsp; &nbsp;เราเก็บข้อมูลอุปกรณ์และการใช้งานเพื่อวัตถุประสงค์ดังนี้:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.1 การจัดการบัญชีผู้ใช้หลายอุปกรณ์
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ระบุอุปกรณ์ที่เข้าใช้งาน เพื่อรักษาความปลอดภัยและจำกัดจำนวนอุปกรณ์พร้อมกัน
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• แสดงรายการ "อุปกรณ์ที่เชื่อมต่อ" ให้ท่านจัดการได้เอง
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.2 การส่งการแจ้งเตือน (Push Notification)
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ส่งข้อมูลราคาผลผลิต เตือนกิจกรรมในฟาร์ม และข่าวสารเกษตรกรรม
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• จัดส่งไปยังอุปกรณ์ที่ท่านใช้งานจริงเท่านั้น เพื่อไม่รบกวน
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.3 การตรวจจับและแจ้งเตือนความปลอดภัย
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ตรวจสอบการเข้าใช้งานผิดปกติ เช่น login จากอุปกรณ์ใหม่ในพื้นที่ไกลกัน
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ส่ง OTP ยืนยันตัวตนเพิ่มเติมเพื่อป้องกันการใช้งานโดยไม่ได้รับอนุญาต
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.4 การแก้ไขปัญหาและปรับปรุงแอปพลิเคชัน
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• บันทึก crash reports เพื่อแก้ไข bugs ที่เกิดขึ้นกับอุปกรณ์หรือระบบปฏิบัติการเฉพาะ
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• วิเคราะห์การใช้งานเพื่อพัฒนาฟีเจอร์ที่ตอบโจทย์เกษตรกรมากขึ้น
        </p>
        <p>
          &nbsp; &nbsp;ข้อมูลที่เก็บรวบรวม:
        </p>
        <p>
          &nbsp; &nbsp; • รหัสประจำอุปกรณ์ (Device ID)
        </p>
        <p>
          &nbsp; &nbsp; •  ชนิดและรุ่นอุปกรณ์
        </p>
        <p>
          &nbsp; &nbsp; •  ระบบปฏิบัติการและเวอร์ชัน
        </p>
        <p>
          &nbsp; &nbsp; • ข้อมูลการใช้งานแอปพลิเคชัน (เช่น หน้าจอที่เข้าชม, ระยะเวลาการใช้งาน)
        </p>
        <p>
          &nbsp; &nbsp; • ข้อมูล IP Address และพื้นที่ทั่วไป (ไม่เก็บตำแหน่งที่แน่นอน)
        </p>

        <p>
          <h2 style={{ fontSize: "20px", marginTop: "24px" }}>3. สิทธิของผู้ใช้งาน</h2>
        </p>

        <p>
          &nbsp; &nbsp;คุณสามารถแก้ไขหรือลบข้อมูลของคุณได้โดยติดต่อ kasetkorn.app@gmail.com เราจะดำเนินการตาม PDPA อย่างเคร่งครัด
        </p>
        <p>
          &nbsp; &nbsp;สิทธิของท่านตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล:
        </p>

        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคล
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการลบข้อมูลส่วนบุคคล (Right to be Forgotten)
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการโอนย้ายข้อมูลส่วนบุคคล
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล
        </p>

        <p>
          <h2 style={{ fontSize: "20px", marginTop: "24px" }}>4. การลบบัญชีผู้ใช้งาน (Account Deletion)</h2>
        </p>

        <p>
          &nbsp; &nbsp;ท่านสามารถลบบัญชีผู้ใช้งานได้ผ่าน ปุ่มลบบัญชีในหน้า Settings ของแอปพลิเคชัน เมื่อลบบัญชีแล้ว ข้อมูลส่วนบุคคลทั้งหมดจะถูกลบออกจากระบบภายใน 30 วัน
        </p>
        <p>
          &nbsp; &nbsp;หมายเหตุ: การลบบัญชีจะส่งผลให้ท่านไม่สามารถเข้าถึงข้อมูลการจัดการฟาร์ม ประวัติการใช้งาน และข้อมูลที่เกี่ยวข้องทั้งหมด กรุณาพิจารณาอย่างรอบคอบก่อนดำเนินการ
        </p>

        <p>
          <h2 style={{ fontSize: "20px", marginTop: "24px" }}>5. การปกป้องข้อมูล</h2>
        </p>

        <p>
          &nbsp; &nbsp;เราให้ความสำคัญกับความปลอดภัยของข้อมูลส่วนบุคคลของท่านเป็นอย่างยิ่ง เราได้นำมาตรการรักษาความปลอดภัยทางเทคนิคและองค์กรที่เหมาะสมมาใช้ เพื่อปกป้องข้อมูลส่วนบุคคลของท่านจากการสูญหาย การเข้าถึง การใช้ การเปลี่ยนแปลง การแก้ไข หรือการเปิดเผยโดยไม่ได้รับอนุญาต
        </p>

        <p>
          &nbsp; &nbsp;มาตราการรักษาความปลอดภัย:
        </p>

        <p>
          &nbsp; &nbsp; &nbsp;• เข้ารหัสข้อมูลส่วนบุคคลด้วยมาตรฐาน SSL/TLS
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• จำกัดการเข้าถึงข้อมูลเฉพาะบุคลากรที่ได้รับอนุญาตเท่านั้น
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• สำรองข้อมูลสม่ำเสมอเพื่อป้องกันการสูญหาย
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• ตรวจสอบและอัพเดตระบบรักษาความปลอดภัยอย่างสม่ำเสมอ
        </p>

        <p>
          <h2 style={{ fontSize: "20px", marginTop: "24px" }}>6. ระยะเวลาเก็บรักษาข้อมูล</h2>
        </p>

        <p>
          &nbsp; &nbsp;เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตลอดระยะเวลาที่จำเป็นเพื่อบรรลุวัตถุประสงค์ตามที่ระบุไว้ในนโยบายนี้ เว้นแต่กฎหมายจะกำหนดหรืออนุญาตให้มีระยะเวลาการเก็บรักษานานขึ้น
        </p>
        <p>
          &nbsp; &nbsp;หากท่านไม่ใช้งานบัญชีเป็นระยะเวลาเกิน 2 ปี ข้อมูลส่วนบุคคลของท่านจะถูกลบออกจากระบบโดยอัตโนมัติ
        </p>

        <p>
          <h2 style={{ fontSize: "20px", marginTop: "24px" }}>7. การติดต่อ</h2>
        </p>

        <p>
          &nbsp; &nbsp;หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ กรุณาติดต่อเราได้ที่:
        </p>
        <p>
          &nbsp; &nbsp;บริษัท: บริษัท แอโร กรุ๊ป (1992) จำกัด
        </p>
        <p>
          &nbsp; &nbsp;อีเมล: kasetkorn.app@gmail.com
        </p>
        <p>
          &nbsp; &nbsp;เว็บไซต์: https://agriculture.kasetkorn.app
        </p>

        <p>
          &nbsp; &nbsp;ไลน์: @kasetkorn
        </p>

        <p><center>
          &nbsp; &nbsp;นโยบายฉบับนี้มีผลบังคับใช้ตั้งแต่ 9 ธันวาคม 2568
        </center></p>

        <p><center>
          &nbsp; &nbsp;เราขอสงวนสิทธิ์ในการปรับปรุงหรือแก้ไขนโยบายนี้เป็นครั้งคราว
        </center>
        </p>


      </div>
      <div
        style={{
          backgroundColor: "white",
          width: "210mm",
          minHeight: "297mm",
          padding: "20mm",
          margin: "40px 0",
          borderRadius: "6px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
        }}
      >
        <h1 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
          Privacy Policy
        </h1>

        <p>
          &nbsp; &nbsp;<strong>Kasetkorn</strong> is a platform developed by <strong>Aero Group (1992) Co., Ltd.</strong> for durian farm management and application for GAP (Good Agricultural Practice) standards, focusing on enabling farmers to manage their farms efficiently.
        </p>
        <p>
          &nbsp; &nbsp; The use of data collected through your use of our services is limited to the purpose of providing services for which you have engaged with us. This Privacy Policy explains how we collect, process, use, disclose, and protect the security of the personal information you provide. For the purposes of this Privacy Policy, Personal Information shall mean any data relating to the identification or personal details of an individual.
        </p>
        <p>
          &nbsp; &nbsp; By consenting to or creating Personal Data and Anonymous Data through our mobile application, you agree to this Privacy Policy and explicitly authorize the processing of your Personal Data and Anonymous Data in accordance with this Privacy Policy.
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>1. Data Collection</h2>
        <p>
          &nbsp; &nbsp; When you use our application, we may collect Personal Data and Anonymous Data from you. This data will be used to effectively provide services to you and to improve the user experience.
        </p>
        <p>
          &nbsp; &nbsp;Data We Collect: We collect Personal Data and Anonymous Data from you when you use our mobile application and when you send information and communications to us. "Personal Data" means information that allows others to identify or contact you, including your name, telephone number, postal code, location coordinates, and email address. "Anonymous Data" means information about you that is not related or connected to Personal Data.
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>2. Our Use of Data</h2>
        <p>
          &nbsp; &nbsp;The Personal Data you provide to us will be used for various purposes, including: for creating and maintaining your account, for the management and provision of our services, for identifying you in the system, for sending confirmation emails upon new account creation, for sending notifications you have set, for improving and developing our services, and for communications related to the use of services.
        </p>
        <p>
          &nbsp; &nbsp;2.1 Location/GPS Data
        </p>
        <p>
          &nbsp; &nbsp;Purpose of Data Collection:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Displaying farm locations on the map to enable farmers to manage planting areas efficiently.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Recording farm coordinates for reference and production planning.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Searching for and recommending nearby durian planting areas for information exchange among farmers.
        </p>
        <p>
          &nbsp; &nbsp;Note: Location data will be used strictly within the context of farm management and will not involve real-time location tracking.
        </p>
        <p>
          &nbsp; &nbsp;2.2 National Identification Card Number
        </p>
        <p>
          &nbsp; &nbsp;Purpose of Data Collection:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Verifying the farmer's identity (Know Your Customer - KYC) for account security and prevention of unauthorized use.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Connecting the database with the Department of Agricultural Extension (or equivalent government agency) for GAP certification application and government support programs for farmers.
        </p>
        <p>
          &nbsp; &nbsp;Data Protection: The National ID card number will be encrypted and securely stored in accordance with the standards of the Personal Data Protection Act (PDPA) B.E. 2562 (2019). It will not be disclosed to any third party without explicit authorization.
        </p>
        <p>
          &nbsp; &nbsp;2.3 Device ID and Usage Data (Analytics)
        </p>
        <p>
          &nbsp; &nbsp;We collect device and usage data for the following purposes:
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.1 Management of multi-device user accounts
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Identifying the accessing devices to maintain security and limit the number of simultaneous devices.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Displaying a list of "Connected Devices" for your own management.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.2 Sending Push Notifications
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Sending information on produce prices, farm activity reminders, and agricultural news.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Delivering notifications only to the device you are actively using to avoid disturbance.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.3 Security Detection and Alerting
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Monitoring for abnormal access, such as a login from a new device in a distant area.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Sending additional OTP authentication to prevent unauthorized use.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2.3.4 Troubleshooting and Application Improvement
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Recording crash reports to fix bugs occurring on specific devices or operating systems.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Analyzing usage to develop features that better meet the needs of farmers.
        </p>
        <p>
          &nbsp; &nbsp;Data Collected:
        </p>
        <p>
          &nbsp; &nbsp; • Device ID
        </p>
        <p>
          &nbsp; &nbsp; • Device type and model
        </p>
        <p>
          &nbsp; &nbsp; • Operating System and Version
        </p>
        <p>
          &nbsp; &nbsp; • Application usage data (e.g., screens visited, duration of use)
        </p>
        <p>
          &nbsp; &nbsp; • IP Address and general location (not precise coordinates)
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>3. User Rights</h2>

        <p>
          &nbsp; &nbsp;You may modify or delete your data by contacting kasetkorn.app@gmail.com. We will strictly adhere to the PDPA in processing your request.
        </p>
        <p>
          &nbsp; &nbsp;Your Rights under the Personal Data Protection Act:
        </p>

        <p>
          &nbsp; &nbsp; &nbsp;• Right to access and request a copy of your Personal Data
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Right to rectification of your inaccurate Personal Data
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Right to erasure of your Personal Data (Right to be Forgotten)
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Right to restriction of processing of your Personal Data
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Right to data portability
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Right to object to the processing of your Personal Data
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>4. Account Deletion</h2>

        <p>
          &nbsp; &nbsp;You can delete your user account via the "Delete Account" button on the Settings page of the application. Once the account is deleted, all Personal Data will be removed from the system within 30 days.
        </p>
        <p>
          &nbsp; &nbsp;Note: Account deletion will result in your inability to access all farm management data, usage history, and related information. Please consider this carefully before proceeding.
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>5. Data Security</h2>

        <p>
          &nbsp; &nbsp;We highly prioritize the security of your Personal Data. We have implemented appropriate technical and organizational security measures to protect your Personal Data from loss, unauthorized access, use, alteration, modification, or disclosure.
        </p>

        <p>
          &nbsp; &nbsp;Security Measures:
        </p>

        <p>
          &nbsp; &nbsp; &nbsp;• Encryption of Personal Data using SSL/TLS standards.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Limiting data access exclusively to authorized personnel.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Regular data backups to prevent loss.
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;• Ongoing review and update of security systems.
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>6. Data Retention Period</h2>

        <p>
          &nbsp; &nbsp;We will retain your Personal Data for the duration necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law.
        </p>
        <p>
          &nbsp; &nbsp;If your account remains inactive for a period exceeding 2 years, your Personal Data will be automatically deleted from the system.
        </p>

        <h2 style={{ fontSize: "20px", marginTop: "24px" }}>7. Contact Information</h2>

        <p>
          &nbsp; &nbsp;Should you have any questions or concerns regarding this Privacy Policy, please contact us at:
        </p>
        <p>
          &nbsp; &nbsp;Company: Aero Group (1992) Co., Ltd.
        </p>
        <p>
          &nbsp; &nbsp;Email: kasetkorn.app@gmail.com
        </p>
        <p>
          &nbsp; &nbsp;Website: https://agriculture.kasetkorn.app
        </p>

        <p>
          &nbsp; &nbsp;Line: @kasetkorn
        </p>

        <p><center>
          &nbsp; &nbsp;This policy is effective as of December 9, 2025.
        </center></p>

        <p><center>
          &nbsp; &nbsp;We reserve the right to update or amend this policy from time to time.
        </center>
        </p>


      </div>
    </>
  );
}